import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { amber, green } from '@mui/material/colors'
import { Snackbar, SnackbarContent } from '@mui/material'
import { CheckCircle, Error, Info, Warning } from '@mui/icons-material'
const styles = {
  neutral: {
    backgroundColor: '#f5f5f5',
    opacity: 0.8
  },
  success: {
    backgroundColor: green[600],
    opacity: 0.8
  },
  warning: {
    backgroundColor: amber[700],
    opacity: 0.8
  },
  error: {
    backgroundColor: 'red',
    opacity: 0.8
  },
  message: {
    display: 'flex',
    alignItems: 'center'
  },
  messageIcon: {
    marginRight: '0.5em'
  }
}

const variantIcon = {
  success: CheckCircle,
  warning: Warning,
  error: Error,
  info: Info
}

class Feedback extends Component {
  render () {
    const { open, message, onAutoClose, closeTimeout, variant } = this.props
    const Icon = variantIcon[variant]
    const timeout = closeTimeout || 3000
    return (
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        open={open}
        autoHideDuration={timeout}
        onClose={onAutoClose}
      >
        <SnackbarContent
          sx={{ ...styles[variant] }}
          message={
            <span style={styles.message}>
              <Icon style={styles.messageIcon} />
              {message}
            </span>
          }
        />
      </Snackbar>
    )
  }
}

Feedback.propTypes = {
  open: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']).isRequired,
  onAutoClose: PropTypes.func.isRequired,
  closeTimeout: PropTypes.number
}

export default Feedback
